module.exports = __webpack_public_path__ + "img/fifa.75a089db.png";